import React from 'react';

import { SVGComponentProps } from './svg.types';

const SearchSVG = ({
  fill = 'currentColor',
  size = '14',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <g opacity="0.8">
          <path
            d="M5.86877 0C2.63669 0 0 2.63669 0 5.86877C0 9.10085 2.63669 11.7375 5.86877 11.7375C7.11057 11.7375 8.28433 11.3463 9.23694 10.6829L11.9177 13.3636C12.2691 13.7151 12.839 13.7151 13.1905 13.3636L13.3636 13.1905C13.7151 12.839 13.7151 12.2691 13.3636 11.9177L10.6659 9.21993C11.3293 8.26731 11.7205 7.11057 11.7205 5.85176C11.7375 2.6367 9.10085 0 5.86877 0ZM5.86877 9.69623C3.75942 9.69623 2.04131 7.97813 2.04131 5.86877C2.04131 3.75942 3.75942 2.04131 5.86877 2.04131C7.97813 2.04131 9.69623 3.75942 9.69623 5.86877C9.69623 7.97813 7.97813 9.69623 5.86877 9.69623Z"
            fill={fill}
          />
        </g>
      </svg>
    </span>
  );
};

export default SearchSVG;
